import { getHours as dateFnsGetHours } from 'date-fns';

const getHours = date => (dateFnsGetHours(new Date(date)));

export default getHours;
